var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHomeTabTitleUp = function SvgIconHomeTabTitleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.457 7.932c.181 0 .343-.03.484-.088a1 1 0 0 0 .364-.26 1.12 1.12 0 0 0 .224-.408c.053-.163.08-.347.08-.552V3.172H8.96v3.452c0 .357-.059.685-.176.984-.115.299-.28.556-.496.772a2.247 2.247 0 0 1-.788.504c-.31.12-.657.18-1.044.18-.39 0-.739-.06-1.048-.18a2.247 2.247 0 0 1-.788-.504 2.184 2.184 0 0 1-.496-.772 2.724 2.724 0 0 1-.172-.984V3.172h1.352V6.62c0 .205.025.39.076.552.053.16.13.297.228.412.099.112.219.199.36.26.144.059.307.088.488.088Zm5.616-1.9c.352 0 .605-.084.76-.252.155-.168.232-.403.232-.704 0-.133-.02-.255-.06-.364a.785.785 0 0 0-.492-.464 1.344 1.344 0 0 0-.44-.064h-.704v1.848h.704Zm0-2.86c.41 0 .763.05 1.056.148.296.096.539.23.728.4.192.17.334.372.424.604.09.232.136.483.136.752 0 .29-.046.557-.14.8-.093.243-.236.45-.428.624-.192.173-.436.31-.732.408a3.37 3.37 0 0 1-1.044.144h-.704V9h-1.352V3.172h2.056Z",
    fill: "#DD3955"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 11,
    rx: 1.5,
    stroke: "#DD3955"
  })));
};
export default SvgIconHomeTabTitleUp;